import { module } from 'modujs';
import Tween from '../class/Tween'
import { lazyLoadImage } from '../utils/image';
import { createFocusTrap } from 'focus-trap';


export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggler: 'toggle'
            }
        }

        this.activeClass = "-open"

        // this.focusTrapOptions = {
        //     /**
        //      * There is a delay between when the class is applied
        //      * and when the element is focusable
        //      */
        //     checkCanFocusTrap: (trapContainers) => {
        //         const results = trapContainers.map((trapContainer) => {
        //             return new Promise((resolve) => {
        //                 const interval = setInterval(() => {
        //                     if (getComputedStyle(trapContainer).visibility !== 'hidden') {
        //                         resolve();
        //                         clearInterval(interval);
        //                     }
        //                 }, 5);
        //             });
        //         });

        //         // Return a promise that resolves when all the trap containers are able to receive focus
        //         return Promise.all(results);
        //     },

        //     onActivate: () => {
        //         this.$currentItem.classList.add(this.activeClass);
        //         this.$currentItem.setAttribute('aria-hidden', false)
        //     },

        //     onPostActivate: () => {
        //         if (this.toggler) {
        //             this.toggler.setAttribute('aria-expanded', true);
        //         }
        //     },

        //     onDeactivate: () => {
        //         this.$currentItem.classList.remove(this.activeClass);
        //         this.$currentItem.setAttribute('aria-hidden', true)
        //     },

        //     onPostDeactivate: () => {
        //         if (this.toggler) {
        //             this.toggler.setAttribute('aria-expanded', false);
        //             this.toggler = null;
        //         }
        //     },
        // };
    }

    init() {
        const $collapsibles = this.el.querySelectorAll('[data-accordions="content"]');
        for (let index = 0; index < $collapsibles.length; index++) {
            const $element = $collapsibles[index];
            $element.style.visibility = "hidden"
        }

        this.lastItemIndex = null
        this.bindEvents()
    }

    /**
     * Toggler
     *
     * @param item {node}
     */
    toggle(e) {
        let item = e.curTarget
        let parent = item.parentNode

        if (parent.classList.contains(this.activeClass)) {
            this.close()
        } else {
            this.close()
            this.open(parent)
        }
    }

    /**
     * open
     *
     * @param parentNode item {node}
     */
    open(item) {
        this.$currentItem = item
        // this.focusTrap = createFocusTrap(item, this.focusTrapOptions);
        // this.focusTrap?.activate?.();

        let $collapsible = item.querySelector('[data-accordions="content"]')

        this.lastItemIndex = Array.from(item.parentNode.children).indexOf(item)

        let img = item.querySelectorAll('[data-lazy]')
        img ??= false

        if (img) {
            img.forEach((item) => {
                lazyLoadImage(item)
            })
        }

        $collapsible.style.visibility = "visible"

        requestAnimationFrame(() => {
            const $inner = item.querySelector('[data-accordions="inner"]');
            let tween = new Tween({
                from: 0,
                to: this.compute($inner).height,
                duration: 200,
                onProgress: (progress = number) => {
                    $collapsible.style.height = progress + "px"
                },
                onComplete: () => {
                    this.$currentItem.classList.add(this.activeClass)
                    this.call('scrollTo', [item, { duration: 800, offset: -80 }], 'Scroll', 'main')
                }
            })
            tween.start()
        })
    }


    /**
     * Close
     *
     * @param
     */
    close() {
        if (this.lastItemIndex == null) return

        let item = this.$('item')[this.lastItemIndex]

        //this.focusTrap?.deactivate?.();

        const $collapsible = item.querySelector('[data-accordions="content"]')

        if ($collapsible) {
            let tween = new Tween({
                from: this.compute($collapsible).height,
                to: 0,
                duration: 200,
                onProgress: (progress = number) => {
                    $collapsible.style.height = progress + "px"
                },
                onComplete: () => {
                    requestAnimationFrame(() => {
                        item.classList.remove(this.activeClass)
                        $collapsible.style.visibility = "hidden"
                    })
                }
            })
            tween.start()
        }

        this.lastItemIndex = null
    }

    /**
     * compute
     *
     * @param
     */
    compute(item) {
        return item.getBoundingClientRect()
    }

    /**
     * bindEvents
     *
     * @param
     */
    bindEvents() {
        this.bindOnResize = this.onResize.bind(this)
        window.addEventListener('resize', this.bindOnResize)
    }

    /**
     * unbindEvents
     *
     * @param
     */
    unbindEvents() {
        window.removeEventListener('resize', this.bindOnResize)
    }

    /**
     * onResize
     *
     * @param
     */
    onResize() {
        if (this.lastItemIndex == null) return
        const $item = this.$('item')[this.lastItemIndex]
        const $collapsible = $item.querySelector('[data-accordions="content"]')
        const $collapsibleInner = $item.querySelector('[data-accordions="inner"]')

        requestAnimationFrame(() => {
            $collapsible.style.height = this.compute($collapsibleInner).height + "px"
        })
    }

    /**
     * destroy
     *
     * @param
     */
    destroy() {
        super.destroy();
        this.unbindEvents()
    }
}
